import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Svg } from 'assets';
import { DashboardWidgetShell, DashboardWidgetSkeleton } from './widgets';
import { EmptyStateDashboard } from './emptyStateDashboard';
import { FindLoad } from 'utils';
import { dashboardActions } from 'store';

const ACTION_TYPE = 'GET_DASHBOARD_SESSION_NOTE_REQUESTS';

export const SessionNoteRequests = ({ item, handleDeleteWidget }) => {
    const dispatch = useDispatch();
    const { sessionNoteRequests } = useSelector((state) => ({
        sessionNoteRequests: state.dashboard.sessionNoteRequests,
    }));
    const loader = FindLoad(ACTION_TYPE);
    const requests = sessionNoteRequests?.requests || [];

    useEffect(() => {
        if (item?.apiPath) {
            dispatch(dashboardActions.getWidgetsData(ACTION_TYPE, item?.apiPath));
        }
    }, [item?.apiPath]);

    if (loader?.length) {
        return <DashboardWidgetSkeleton />;
    }

    return (
        <DashboardWidgetShell iconId={12} onClose={handleDeleteWidget}>
            <div className="main-dashboard-card-body">
                {requests?.length ? (
                    <div className="session-note-req-list">
                        {requests.map((req, index) => (
                            <div className="session-note-req-row" key={req?.id || index}>
                                <div className="session-note-req-row__icon">
                                    <Svg.SessionNoteDocSvg />
                                </div>

                                <div className="session-note-req-row__body">
                                    <p className="session-note-req-row__code">{req?.code}</p>
                                    <p className="session-note-req-row__sub">
                                        Requested by {req?.requestedBy}
                                        <span className="session-note-req-row__dot" />
                                        {req?.date}
                                    </p>
                                </div>

                                {req?.type === 'ADD' ? (
                                    <button type="button" className="session-note-req-row__add" aria-label="Add note">
                                        <Svg.SessionNoteAddSvg />
                                    </button>
                                ) : (
                                    <button type="button" className="session-note-req-row__update">
                                        Update
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <EmptyStateDashboard
                        iconId={12}
                        title="No session note requests"
                        description={'Pending session note requests from your team will appear here'}
                    />
                )}
            </div>
        </DashboardWidgetShell>
    );
};
